module.exports = __webpack_public_path__ + "img/logo-horizontal.ef29611f.svg";